import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { MainMenuActiveContext } from '../context/MainMenuActiveContext';
import { FaBlog, FaBoxOpen, FaCalendarAlt, FaCarSide, FaInfoCircle, FaQuoteLeft, FaRegNewspaper, FaUsers, FaUserTie } from "react-icons/fa";
import { Menu } from 'antd';
import { MdDashboard, MdLocalOffer, MdMenuBook, MdOutlineAppSettingsAlt } from "react-icons/md";
import { LiaElementor } from "react-icons/lia";
import { CgWebsite } from "react-icons/cg";
import { IoMdPeople } from 'react-icons/io';
import { MainProfileContext } from '../context/MainProfileContext';
import { removeTokenSession } from '../utils/common';
import usePost from '../customHooks/usePost';
import { toast } from 'react-toastify';
import config from "../services/config.json";


const links = {
  "/": "sub1",
  "/users": "sub2",
  "/users/create": "sub3",
  "/users/edit": "sub4",
  "/blogs": "sub11",
  "/blogs/create": "sub11",
  "/blogs/edit": "sub11",
  "/elements": "sub16",
  "/webcontent": "sub17",
  "/appcontent": "sub18",
  "/products/coverages": "sub36",
  "/products/coverages/create": "sub36",
  "/products/coverages/edit": "sub36",
};

function getItem(label, key, icon, children, type) {
  return { key, icon, children, label, type };

}

const LeftSide = ({ permissions, data }) => {
  const navigate = useNavigate();
  const { handleProfileData, profileData } = useContext(MainProfileContext);
  const { Users, Roles, Partners, Testimonials } = permissions
  useEffect(() => {
    handleProfileData(data)
  }, [])

  const [res, apiMethod] = usePost()
  const handleLogOut = () => {

    let formdata = new FormData();
    apiMethod("logout", formdata)
  };
  useEffect(() => {
    if (res.data) {
      if (res.data.status === "false") {
        toast.error(res.data.message);
      }
      else {
        toast.success(res.data.message);
        removeTokenSession();
        navigate(`/${config.demo}login`);
      }
    }
  }, [res.data, navigate])

  const location = useLocation();
  // let abc = []
  // if(location.pathname.includes("case") || location.pathname.includes("case/update") || location.pathname.includes("case/inquires")) {
  //     abc = ["sub3"]
  // }
  // else if(location.pathname.includes("services") || location.pathname.includes("service/category")) {
  //     abc = ["sub19"]
  // }
  // else {
  //     abc = []
  // }
  const [openKeys, setOpenKeys] = useState("");
  let a = location.pathname.split("/")
  a.pop()
  let pathsplit = location.pathname.includes("edit") ? a.join("/") : location.pathname;
  const [selectedKey, setSelectedKey] = useState([links[pathsplit]])
  const rootSubmenuKeys = [
    'sub1', 'sub2', 'sub3', 'sub4', 'sub5', 'sub6', 'sub7', 'sub8', 'sub9',
    'sub10', 'sub11', 'sub12', 'sub13', 'sub14', 'sub15', 'sub16', 'sub17',
    'sub18', 'sub19', 'sub20', 'sub21', 'sub22', 'sub23', 'sub24', 'sub25',
    'sub26', 'sub27', 'sub28', 'sub29', 'sub30', 'sub31', 'sub32', 'sub33',
    'sub34', 'sub35', 'sub36',
    'sub37', 'sub38', 'sub39', 'sub40', 'sub41'
    , 'sub42', 'sub43', 'sub44'
    , 'sub45', 'sub46', 'sub47'
  ];
  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) == -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) == -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  let User = null
  let Role = null
  let partners = null
  let testimonials = null
  let blogssidebar = null
  let promotion = null
  let blogs = null
  let Enquiry = null
  let Booking = null
  let promo = null
  let catalogs = null
  let WebContent = null
  let Products = null
  let Reviews = null



  const check = (module, action) => permissions?.[module]?.includes(action);
  let Dashboard = getItem(<Link to={`/`}>Dashboard</Link>, 'sub1', <MdDashboard />)
  if ((check("Users", "User View") && check("Users", "User Menu"))) {
    User = getItem(<Link to={`/users`}>Users</Link>, 'sub2', <IoMdPeople />)
  }

  // if (Users?.includes("User Menu")) {
  //   const children = [];
  //   // if (Users?.includes("User Menu")) children.push(getItem(<Link to="/users/create">Create</Link>, 'sub3'));
  //   if (Users?.includes("User View")) children.push(getItem(<Link to="/users">User List</Link>, 'sub4'));
  // }
  if ((check("Roles", "Role View") && check("Roles", "Role Menu"))) {
    Role = getItem(<Link to={`/role`}>Roles</Link>, 'sub5', <FaUserTie />);
  }

  // if (Roles?.includes("Role Menu")) {
  //   const children = [];
  //   // if (Roles.includes("Role Menu") && Roles.includes("Role Add")) children.push(getItem(<Link to={`/role/create`}>Create</Link>, 'sub6'));
  //   if (Roles.includes("Role View")) children.push(getItem(<Link to={`/role`}>Role List</Link>, 'sub7'));
  // }

  // partners = getItem(<Link to={`/partners`}>Partners</Link>, 'sub14', <FaUsers />);

  // if (Partners?.includes("Partner Menu")) {
  //   const children = [];
  //   // if (Partners.includes("Partner Menu") && Partners.includes("Partner Add")) children.push(getItem(<Link to={`/partners/create`}>Create</Link>, 'sub16'));
  //   if (Partners.includes("Partner View")) children.push(getItem(<Link to={`/partners/`}>Partners List</Link>, 'sub15'));
  // }
  if ((check("Testimonials", "Testimonial View") && check("Testimonials", "Testimonial Menu"))) {
    testimonials = getItem(<Link to={`/testimonials`}>Testimonials</Link>, 'sub26', <FaQuoteLeft />);
  }

  // if (Testimonials?.includes("Testimonial Menu")) {
  //   const children = [];
  //   // if (Testimonials.includes("Testimonial Menu") && Testimonials.includes("Testimonial Add")) children.push(getItem(<Link to={`/testimonials/create`}>Create</Link>, 'sub23'));
  //   if (Testimonials.includes("Testimonial View")) children.push(getItem(<Link to={`/testimonials/`}>Testimonials List</Link>, 'sub24'));
  // }


  if ((check("Promotions", "Promotion View") && check("Promotions", "Promotion Menu"))) {
    promotion = getItem(<Link to={`/promotions`}>Promotions</Link>, 'sub13', <MdLocalOffer />)
  }

  if ((check("Blogs", "Blogs View") && check("Blogs", "Blogs Menu"))) {
    blogs = getItem(<Link to={`/blogs`}>Blogs</Link>, 'sub10', <FaBlog />)
    if ((check("Blogs", "Blogs View") && check("Blogs", "Blogs Menu"))) {
      const children = [];
      if (check("Blogs", "Blogs Add")) children.push(getItem(<Link to="/blogs/sidebar/create">Create</Link>, 'sub66-1'));
      if (check("Blogs", "Blogs View")) children.push(getItem(<Link to="/blogs/sidebar">Blogs Sidebar List</Link>, 'sub66-2'));
      blogssidebar = getItem("Blogs Slider", 'sub66', <IoMdPeople />, children);
    }
  }

    if ((check("WebContents", "WebContents View") && check("WebContents", "WebContents Menu"))) {
      WebContent = getItem(<Link to={`/webcontent`}>WebContent</Link>, 'sub21', <CgWebsite />)
    }
    let quote = getItem(<Link to={`/quote`}>Quote</Link>, 'sub22', <MdOutlineAppSettingsAlt />)


    if ((check("Catalogs", "Catalogs View") && check("Catalogs", "Catalogs Menu"))) {
      catalogs = getItem(<Link to={`/catalogs`}>Catalogs</Link>, 'sub29', <MdMenuBook />)
    }

    // let carwithdriver = getItem(<Link to={`/carwithdrivers`}>Car With Driver</Link>, 'sub47',<FaCarSide />)
    if ((check("Products", "Products View") && check("Products", "Products Menu"))) {
      Products = getItem("Products", 'sub30', <FaBoxOpen />, [
        getItem(<Link to={`/products`}>Products List</Link>, 'sub32'),
        getItem(<Link to={`/products/properties`}>Products Properties List</Link>, 'sub35'),
        getItem(<Link to={`/products/coverages`}>Products Coverages List</Link>, 'sub38'),
      ])
    }
    // let ProductsProperties = getItem("Products Properties", 'sub33', <FaRegNewspaper />, [
    //   // getItem(<Link to={`/products/properties/create`}>Create</Link>, 'sub34'),
    // ])
    // let ProductsCoverages = getItem("Products Coverages", 'sub36', <FaRegNewspaper />, [
    //   // getItem(<Link to={`/products/coverages/create`}>Create</Link>, 'sub37'),
    // ])

    if ((check("PromoCode", "PromoCode View") && check("PromoCode", "PromoCode Menu"))) {
      promo = getItem(<Link to={`/promo`}>Promo</Link>, 'sub41', <MdLocalOffer />)
    }
    if ((check("Booking", "Booking View") && check("Booking", "Booking Menu"))) {
      Booking = getItem(<Link to={`/booking`}>Booking</Link>, 'sub42', <FaCalendarAlt />)
    }
    if ((check("Enquiry", "Enquiry View") && check("Enquiry", "Enquiry Menu"))) {
      Enquiry = getItem(<Link to={`/lead`}>Enquiry</Link>, 'sub43', <FaInfoCircle />)
    }
      if ((check("Reviews", "Reviews View") && check("Reviews", "Reviews Menu"))) {
    Reviews = getItem(<Link to="/reviews">Reviews</Link>, 'sub63', <MdDashboard />);
  }

    let items = []
    items = [
      Dashboard,
      User,
      Role,
      Booking,
      Enquiry,
      Products,
      // ProductsProperties,
      // ProductsCoverages,
      catalogs,
      // carwithdriver,
      blogs,
      blogssidebar,
      promotion,
      promo,
      partners,
      testimonials,
      // elements,
      Reviews,
      WebContent,
      // quote
    ];


    const { getActive, handleGetEditValue } = useContext(MainMenuActiveContext);
    return (
      <div className={`MainDashboard__left w-[18rem] relative max-lg:absolute max-lg:w-full z-[12] max-lg:z-50 max-lg:h-svh transition-all duration-300  py-5 pl-4 ${getActive ? "active" : ""}`}>
        <div className="absolute inset-0 bg-black/40 backdrop-blur-[5px] z-[-1]"></div>
        <img src={require("../dist/webImages/rr.png")} className='w-full z-[-2] h-full absolute inset-0 object-cover' alt="" />
        <div className='closeButton hidden max-lg:grid cursor-pointer absolute bg-[#FFCEDA] w-[2rem] h-[2rem] p-[.6rem] top-[.7rem] right-[.7rem]  place-items-center rounded-[.7rem] z-10' onClick={() => handleGetEditValue(false)}>
          <svg className='w-full h-full' width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.8612 1.34766L0.951172 16.2567M15.8612 16.2577L0.951172 1.34863" stroke="#ED2656" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        <div className="logo pt-4 pb-4 pr-6">
          <Link to={`/`} onClick={() => handleGetEditValue(false)}>
            <img src={require("../dist/webImages/logo.png")} className='w-full mx-auto max-lg:m-0' alt="" />
          </Link>
          <div className="flex gap-3 items-center mt-4 justify-center">
            {(data?.role_id !== 10) && <div className='w-6'><Link onClick={() => handleGetEditValue(false)} to={"/setting"} className={` ${location.pathname.includes("setting") ? "text-secondary" : ""}`}><img src={require("../dist/webImages/setting.png")} alt='' /></Link></div>}
            <Link className='' to={"/profile"}><img className='w-6' src={require("../dist/webImages/profile.png")} alt='' /></Link>
            <button className="" onClick={handleLogOut}>
              <img className='w-6' src={require("../dist/webImages/logout.png")} alt='' />
            </button>
          </div>
        </div>
        <nav className='nav max-h-[70vh] overflow-y-auto pr-4'>
          <Menu
            defaultSelectedKeys={selectedKey}
            defaultOpenKeys={["sub19"]}
            mode="inline"
            theme="light"
            items={items}
            className='font-Cinzel text-[1.1rem]'
            openKeys={openKeys}
            onOpenChange={onOpenChange}
          />
        </nav>
      </div>
    )
  }

  export default LeftSide
